// Single shared React Query client for the whole app.
//
// React Query becomes our "server state" layer: it caches every API response by
// key, dedupes in-flight requests, and serves cached data instantly when you
// navigate back to a page — instead of every page re-fetching from scratch in a
// useEffect. Mutations invalidate the relevant keys so lists stay fresh.
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Treat data as fresh for 30s — re-navigating within that window serves
      // the cache with no network call. Tune per-hook where needed.
      staleTime: 30_000,
      // Keep unused data around for 5 min before garbage-collecting it.
      gcTime: 5 * 60_000,
      // We don't need an auto-refetch every time the tab regains focus.
      refetchOnWindowFocus: false,
      // One retry on failure (a 401 is handled globally by api.js → logout).
      retry: 1,
    },
  },
});
